export default "__VITE_ASSET__DUZnJXZa__"